// extracted by mini-css-extract-plugin
export default {"header_wrapper":"NotFound_header_wrapper__V5kHy","wrapper":"NotFound_wrapper__I51p-"};